import React from "react";
import UsersCommon from "../UsersMain";

const ActiveUsers = () => {
  const type = "Activated";
  const title = "Active users";
  return <UsersCommon type={type} title={title} />;
};

export default ActiveUsers;
